<template>
  <div class="full-height theme-bg-gray q-pa-lg text-center waiting">
    <div class="text-weight-bolder font-size-16 q-px-xl">
      <span>{{ $t('waiting.danaMsg') }}</span>
    </div>
    <div class="countDown q-mt-sm">
      <span class="num">
        {{ toMinus((number || 0) / 1000) }}
      </span>
      <span class="unit">m</span>
      <span class="num">
        {{ toSeconds((number || 0) / 1000) }}
      </span>
      <span class="unit">s</span>
    </div>
    <div>
      <PayStepTip type="Dana" />
    </div>
    <div class="paynow">
      <a class="pay" :href="checkUrl" target="_blank" rel="noopener">
        <MButton primary bold>{{ $t('waiting.paynow') }}</MButton>
      </a>
      <MButton :loading="checking" @click="debounceCheck(true)">
        {{ $t('waiting.qrisCheckStatusText') }}
      </MButton>
    </div>
    <BaseLogo />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { checkoutStatus, pullPaymentStatus } from 'src/api/order.js';
import { useInterval } from 'src/utils/hooks/use-interval';
import MButton from 'src/components/MButton';
import { debounce } from 'quasar';
import { useCloseDialog } from 'src/components/dialog';
import { useIns, useStore } from '../../../utils/v2_helper/common';
import {
  toMinus,
  toSeconds,
  useCountDown,
} from '../../../utils/hooks/use-countdown';
import { useRoute } from '../../../utils/v2_helper/router';
import { paySuccess, PAY_STATUS, showPayFailedDialog } from '../config';
import { showDialog } from '../../../utils/error_config';
import PayStepTip from '../components/PayStepTip.vue';

useCloseDialog();
const route = useRoute();
const app = useIns();
const store = useStore();
const { number, start } = useCountDown();
const pid = ref();
const checkUrl = ref('');
const checking = ref(false);
const orderId = computed(() => {
  const q = route.query;
  const id = (q.orderId || q.order_id)?.replace(/\d+_DM/, '');
  store.dispatch('Menu/setOrderId', id);
  return id;
});

const _fn = ref(null);
const { pause } = useInterval(_fn, 3000, true);
const showTimeTip = ref(false);
_fn.value = async (munual) => {
  const oid = pid.value ? `${pid.value}_DM${orderId.value}` : orderId.value;
  const fn = munual ? pullPaymentStatus : checkoutStatus;
  if (munual) checking.value = true;
  try {
    const res = await fn({ orderId: oid });
    const { success, data, code } = res;
    const { orderDetail, paymentStatus, paymentFailureReason } = data || {};
    pid.value = orderDetail?.payments?.[0]?.orderPaymentPreferenceId;

    if (success) {
      checkUrl.value = data.checkout_url;
      if (data?.expiredDate) {
        number.value = data.expiredDate * 1000;
        start();
      } else {
        number.value = 0;
      }
      if (
        data.expiredDate &&
        data.expiredDate < 240 &&
        !showTimeTip.value &&
        paymentStatus === PAY_STATUS.PENDING
      ) {
        showTimeTip.value = true;
        return showPayFailedDialog(app, 'PAY_TIME_TIP');
      }
      if (paymentStatus === PAY_STATUS.FAILED) {
        showPayFailedDialog(app, paymentFailureReason);
        return pause();
      }
      if (paymentStatus === PAY_STATUS.SUCCESS) {
        paySuccess(app, orderDetail);
      }
      if (paymentStatus === PAY_STATUS.PENDING && munual) {
        return showPayFailedDialog(app, PAY_STATUS.PENDING);
      }
    } else {
      showDialog(app, code);
    }
  } finally {
    if (munual) {
      checking.value = false;
    }
  }
};
const debounceCheck = debounce(_fn.value, 400);
</script>

<style lang="scss" scoped>
.waiting {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 72px;
  position: relative;
  min-height: 300px;

  .countDown {
    color: #ff9e2d;
    margin-top: 10px;
    margin-bottom: 20px;

    .num {
      font-weight: bold;
      font-size: 36px;
      line-height: 40px;
    }

    .unit {
      font-size: 16px;
      line-height: 24px;
      vertical-align: super;
    }
  }

  .paynow {
    display: flex;
    flex-direction: column;
    margin-top: auto;
    margin-bottom: 50px;

    & > *,
    .mbtn {
      width: 100%;
    }

    .pay {
      margin-bottom: 16px;
    }
  }
}
</style>
